import styled from 'styled-components'

type SubheaderProps = {
  green?: boolean
  lightBlue?: boolean
  center?: boolean
}

const Subheader = styled.h3<SubheaderProps>`
  /* Color options: green, light blue, or dark blue (default) */
  color: ${props =>
    props.green
      ? props.theme.colorLime
      : props.lightBlue
      ? props.theme.colorLightBlue
      : props.theme.colorDarkBlue};
  text-align: ${props => (props.center ? 'center' : 'left')};
`

export default Subheader
